<template>
    <div>
        <button aria-label="Menu" @click="toggleShow">
            <span class="hamburger__btn"></span>
        </button>

        <transition name="fade">
            <hamburger-menu
                v-if="showHamburger && !isUserLoggedIn"
                @closed="toggleShow">
            </hamburger-menu>

            <user-menu
                v-if="showHamburger && isUserLoggedIn"
                @menu-clicked="toggleShow"
                @closed="toggleShow">
            </user-menu>
        </transition>
    </div>
</template>

<script>
import UserMenu from '@/components/structure/navigation/UserMenu';
import HamburgerMenu from '@/components/structure/navigation/Hamburger';

export default {
    name: 'HelpButton',
    data() {
        return {
            showHamburger: false,
        };
    },
    computed: {
        hamburgerLabel() {
            return this.isUserLoggedIn ? this.$t('HELP_BUTTON_MENU') : this.$t('HELP_BUTTON_HELP');
        },
        isUserLoggedIn: {
            get() {
                return this.$store.getters['auth/isUserLoggedIn'];
            },
        },
    },
    methods: {
        /**
         * Toggle visibility of hamburger menu.
         *
         * @returns {void}
         */
        toggleShow() {
            this.showHamburger = !this.showHamburger;
        },
    },
    components: {
        UserMenu,
        HamburgerMenu,
    },
};
</script>
